__webpack_public_path__ = '/wp-content/plugins/prevent-direct-access-gold-3.0/js/dist/';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import { Popup, WPReTable, Tab, ColumnConfig } from 'wp-react-toolkits';
import { SortIndicator } from 'react-virtualized';
import Immutable from 'immutable';
import { toastr } from 'react-redux-toastr';
import ReduxToastr from 'react-redux-toastr'; ///https://github.com/diegoddox/react-redux-toastr
import store from './store';
import { bindActionCreators } from 'redux';
import {
  fetchUrls,
  newUrl,
  deleteUrl,
  updateUrlStatus,
  updateDataUrl,
  protectThisFile,
  unProtectThisFile,
  isItProtectedFile,
  setDefault,
} from './actions/privateUrls';
import { syncFileToS3, unSyncFileFromS3, checkStatusFile } from './actions/s3';
import { getTotalPrivateLinks } from './actions/stats';
import {
  getUserRolesIpBlock, getMembersSelect,
  addUserRoles, getUsersSelected,
} from './actions/ipBlock';
import { changeTab, registerTab } from './actions/tab';
import { getPlan } from './actions/plan';
import { fetchInitData } from './actions/init';
import { BUTTON_LABELS, MESSAGES, TABS } from './utils/strings';
import { __ } from './components/form/utils';
import UI_Utils from './utils/ui';
import PupForm from './components/form';
import IpBlockForm from './components/ipblock-form';
import UserAccessForm from './components/useraccess-form';
import './index.css';
import 'font-awesome/scss/font-awesome.scss';
import 'wp-react-toolkits/style/table.css';
import 'react-redux-toastr/src/styles/index.scss';
import ReactTooltip from 'react-tooltip';

import { encryptFile, decryptFile } from './api/file';

import AffiliateProgram from './components/affiliate-program';
import PrivateLinkUserForm from './components/private-link-user';

import PDAService from './services';

class App extends Component {
  constructor (props) {
    super(props);
    this.handleClosePopup = this.handleClosePopup.bind(this);
    this.handleShowPopup = this.handleShowPopup.bind(this);
    this.handleProtectFileEvent = this.handleProtectFileEvent.bind(this);
    this.handleAddNewPrivateLink = this.handleAddNewPrivateLink.bind(this);
    this.handleEditPrivateUrl = this.handleEditPrivateUrl.bind(this);
    this.handleCopyPrivateLink = this.handleCopyPrivateLink.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.handleChangeTab = this.handleChangeTab.bind(this);
    this.changeToCustomForm = this.changeToCustomForm.bind(this);
    this.handleProtectThisFile = this.handleProtectThisFile.bind(this);
    this.handleUnProtectThisFile = this.handleUnProtectThisFile.bind(this);
    this.setDefaultPrivateLink = this.setDefaultPrivateLink.bind(this);
    this.checkIsProtectedFile = this.checkIsProtectedFile.bind(this);
    this.syncFileToS3 = this.syncFileToS3.bind(this);
    this.unSyncFile = this.unSyncFile.bind(this);
    this.checkIsMembershipRole = this.checkIsMembershipRole.bind(this);
    this.reload = this.reload.bind(this);
    this.renderFileStatus = this.renderFileStatus.bind(this);
    this.changeToFileAccessPermission = this.changeToFileAccessPermission.bind(
      this);
    this.handleEncryptionFile = this.handleEncryptionFile.bind(this);
    this.handleDecryptionFile = this.handleDecryptionFile.bind(this);

    this.wpData = {
      isLicenseExpired: window.pda_gold_v3_data.is_license_expired,
    };

    this.handleProtectFileEvent();
    this.state = {
      currentPostId: null,
      loadingData: false,
      editingId: null,
      isItProtected: true,
      isEncrypted: false,
      isProcessing: false,
      notLoadingUserRoleData: false,
      notLoadingMembershipData: false,
      post: {
        title: '',
        edit_url: '',
        is_file_deleted: false,
      },
    };
  }

  render () {
    return (
      <div>
        <ReduxToastr
          timeOut={2000}
          newestOnTop={false}
          preventDuplicates={true}
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
        />
        <Popup
          label='Pop up label'
          closeTitle='Close popup'
          insideElement={this.renderTabs()}
          closeBtn={this.renderCloseBtn()}
          onRef={ref => {
            this.child = ref;
          }}
        />
      </div>
    );
  }

	isPlanLite = () => {
		const { plan } = this.props;
		return plan.planName === 'lite';
	}

  renderTabs () {
    const { currentTab, formTabs } = this.props;
    const { isItProtected } = this.state;
    let tabs = [
      {
        name: 'Prevent Direct Access',
        panel: this.renderTableTab(),
      }];

    if (isItProtected) {
      tabs.push({
        name: __('New Download Link'),
        panel: this.renderFormTab(),
      });
      if (typeof (ip_block_server_data) !== 'undefined' &&
        ip_block_server_data.pda_magic_link_activated == -1) {
        const sharedPLTab = formTabs.find(
          tab => 'shared-private-link' === tab.name);
        const sharedPLForm = sharedPLTab ? sharedPLTab.component : null;
        tabs.push({
          name: __('Shared Private Link'),
          panel: this.renderTabPrivateLinkUser(sharedPLForm),
        });
      }

      const arForm = formTabs.find(tab => 'ar-form' === tab.name);
      const arFormComp = arForm ? arForm.component : null;
      const memForm = formTabs.find(tab => 'membership-form' === tab.name);
      const memFormComp = memForm ? memForm.component : null;

      tabs.push({
        name: __('File Access Permission'),
        panel: this.renderUserAccess(arFormComp, memFormComp),
      });
      if (typeof (ip_block_server_data) !== 'undefined' &&
        ip_block_server_data.ip_block_activated == -1) {
        const form = formTabs.find(tab => 'ip-block-form' === tab.name);
        const formComponent = form ? form.component : null;
        tabs.push({
          name: form ? form.title : __('IP Restriction'),
          panel: this.renderIpBlock(formComponent),
        });

        // Add Referral URLs tab
        const refForm = formTabs.find(tab => 'ref-form' === tab.name);
        if (refForm) {
          tabs.push({
            name: refForm.title,
            panel: this.renderRef(refForm.component),
          });
        }
      }
      if (!this.isPlanLite()) {
        tabs.push({
          name: __('Invite & Earn'),
          panel: this.renderAffiliateProgram(),
        });
      }
    }

    return (<div className="fix-css-conflict-yoast-seo">
      <Tab tabs={tabs} onRef={ref => {
        this.childTab = ref;
      }}
           defaultTab={currentTab.tab}/>
    </div>);
  }

  handleChangeTab (index) {
    this.childTab.handleSelect(index);
    this.props.fetchUrls(this.state.currentPostId, this.state.type);
    this.reload();
  }

  handleChangeExpiredDate = (val, id) => {
    const {updateDataUrl} = this.props;
    const current = new Date();
    const datetime = `${val} ${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`;
    const timeStamp = Date.parse(datetime) / 1000;
    updateDataUrl(id, {expired_date: timeStamp}).then(() => {
      const {updateUrlResponse, fetchUrls} = this.props;
      if (updateUrlResponse.result.isError) {
        toastr.error(
          __('Opps! Unable to update the link data. Please try again or contact plugin owner.')
        );
      } else {
        const {currentPostId, type} = this.state;
        toastr.success(MESSAGES.UPDATE_LINK_DATA);
        fetchUrls(currentPostId, type).then(() => {
          this.setState(prevState => ({
            ...prevState,
            editingId: null,
          }));
        });
      }
    });
  };

  handleChangeLimitDownloads (val, id) {
    const {updateDataUrl} = this.props;
    if (val <= 0) {
      val = null;
    }
    updateDataUrl(id, {limit_downloads: val}).then(() => {
      const {updateUrlResponse, fetchUrls} = this.props;
      if (updateUrlResponse.result.isError) {
        toastr.error(
          __('Opps! Unable to update the link data. Please try again or contact plugin owner.')
        );
      } else {
        const {currentPostId, type} = this.state;
        toastr.success(MESSAGES.UPDATE_LINK_DATA);
        fetchUrls(currentPostId, type).then(() => {
          this.setState(prevState => ({
            ...prevState,
            editingId: null,
          }));
        });
      }
    });
  }

  renderTableTab () {
    const { privateUrls } = this.props;
    const { loadingData, isItProtected } = this.state;
    const data = Immutable.List(privateUrls.all);
    const time_now = new Date();
    const unit_time_now = Math.ceil(time_now / 1000);
    const configs = {
      columnsConfig: [
        new ColumnConfig(__('Private Download Links'), 'full_url', false, 600,
          ({cellData, rowData}) => {
            const limit = rowData.limit_downloads == null ||
            Number.parseInt(rowData.limit_downloads) >
            Number.parseInt(rowData.hits_count) ? true : false;
            const isDefault = rowData.is_default === '1'
              && rowData.is_prevented === '1'
              && limit
              && (rowData.expired_date === null || rowData.expired_date >
                unit_time_now);
            return isDefault ? <div
                className={(pda_gold_v3_data.magic_link_activated == -1)
                  ? 'is_default'
                  : ''}><a target="_blank" href={cellData}>{cellData}</a></div> :
              <a target="_blank" href={cellData}>{cellData}</a>;
          }, ({ dataKey, label, sortBy, sortDirection }) => {
            return (
              <span
                className="ReactVirtualized__Table__headerTruncatedText pda-tooltip"
                key="label">
				    {label} <i className="fa fa-lightbulb-o" aria-hidden="true"></i>
				    <span className="tooltiptext">These links are accessible to anyone. You should auto-expire them after a period of time or number of clicks.</span>
                {sortBy === dataKey && <SortIndicator key="SortIndicator"
                                                      sortDirection={sortDirection}/>}
				</span>
            );
          }),
        new ColumnConfig(__('Is it active?'), 'is_prevented', false, 150,
          ({cellData, rowData}) => {
            const {ID, expired_date, limit_downloads, hits_count} = rowData;
            const limit = limit_downloads == null ||
            Number.parseInt(limit_downloads) > Number.parseInt(hits_count)
              ? true
              : false;
            const validity = expired_date == null ||
            Number.parseInt(expired_date) > unit_time_now ? true : false;
            return cellData == 1 && validity && limit ?
              <i className='fa fa-check fa-lg pda-active-link '/>
              : <i className='fa fa-times fa-lg pda-inactive-link'/>;
          }),
        new ColumnConfig(__('Total Clicks'), 'hits_count', true, 150),
        new ColumnConfig(__('Download Limit'), 'limit_downloads', true, 250,
          ({cellData, rowData}) => {
            return this.state.editingId === rowData.ID ? (
                <div>
                  <input className="pda_input_download_limit" type="number" min={1} defaultValue={cellData}
                         onBlur={(evt) => this.handleChangeLimitDownloads(
                           evt.target.value, rowData.ID)}/>
                </div>
              )
              : (
                <div>
                  {cellData
                    ? `${cellData} ${UI_Utils.renderAttempt(cellData)}`
                    : 'Unlimited'}
                </div>
              );
          }, ({
                columnData,
                dataKey,
                disableSort,
                label,
                sortBy,
                sortDirection,
              }) => {
            const showSortIndicator = sortBy === dataKey;
            const children = [
              <span
                className="ReactVirtualized__Table__headerTruncatedText pda-tooltip"
                key="label"
              >
                    {label} <i className="fa fa-lightbulb-o "
                               aria-hidden="true">
                    </i>
                    <span className="tooltiptext">Set a download limit for this URL. Default: Unlimited.</span>
                </span>,
            ];

            if (showSortIndicator) {
              children.push(
                <SortIndicator key="SortIndicator"
                               sortDirection={sortDirection}/>,
              );
            }

            return children;

          }),

        new ColumnConfig(__('Download Expiry'), 'expired_date', false, 300,
          ({cellData, rowData}) => {

            if (this.state.editingId === rowData.ID) {
              const today = new Date();
              today.setDate(today.getDate() + 1);
              const min = UI_Utils.changeDateFormat(today);

              const currentDay = new Date();
              currentDay.setDate(currentDay.getDate());
              const currVal = UI_Utils.changeDateFormat(currentDay);

              return <div><input className="pda_input_download_limit" type="date" min={min} defaultValue={currVal}
                                 onBlur={(evt) => this.handleChangeExpiredDate(
                                   evt.target.value, rowData.ID)}/></div>;
            } else {
              if (cellData) {
                var date = new Date(cellData * 1000);
                // cellData = date.toLocaleDateString();
                cellData = date.toLocaleString();
              } else {
                cellData = 'Never';
              }
              return <div>{cellData}</div>;
            }

          }, ({

                columnData,
                dataKey,
                disableSort,
                label,
                sortBy,
                sortDirection,

              }) => {

            const showSortIndicator = sortBy === dataKey;
            const children = [
              <span
                className="ReactVirtualized__Table__headerTruncatedText pda-tooltip"
                key="label"
              >
                    {label} <i className="fa fa-lightbulb-o "
                               aria-hidden="true">
                    </i>
                    <span className="tooltiptext">Set an expiration date for this URL. Default: Never.</span>
                </span>,
            ];

            if (showSortIndicator) {
              children.push(
                <SortIndicator key="SortIndicator"
                               sortDirection={sortDirection}/>,
              );
            }

            return children;

          }),

        new ColumnConfig(__('Created Time'), 'time', true, 300,
          ({cellData, rowData}) => {
            return new Date(cellData * 1000).toLocaleString();
          }),

        new ColumnConfig('', 'ID', true, 250, ({cellData, rowData}) => {
          const {ID, expired_date, limit_downloads, hits_count, is_prevented} = rowData;

          const isUnderLimit = limit_downloads == null ||
          Number.parseInt(limit_downloads) > Number.parseInt(hits_count)
            ? true
            : false;
          const isStillValidDate = expired_date == null ||
          Number.parseInt(expired_date) > unit_time_now ? true : false;

          const changeStatusLabel = is_prevented === '1' || isUnderLimit ||
          isStillValidDate ? 'De-activate' : 'Activate';
          const activateMagicLink = (pda_gold_v3_data.magic_link_activated ==
            -1) ? '' : 'hidden';

          const ischangeStatusLabel = is_prevented !== '1' ||
          !(isUnderLimit && isStillValidDate)
            ? 'pdav3_table_actions hidden'
            : 'pdav3_table_actions';
          return (
            <div>
                        <span title="Edit"
                              onClick={this.isPlanLite()
                                ? ''
                                : this.handleEditPrivateUrl.bind(this, ID,
                                  cellData)}
                              className="pdav3_table_actions">
                              <i className='fa fa-edit fa-lg'/>
                        </span>
              <span title="Copy to clipboard"
                    onClick={this.handleCopyPrivateLink.bind(this, cellData)}
                    className="pdav3_table_actions">
                              <i className="fa fa-copy fa-lg"/>
                </span>
              <span title={changeStatusLabel}
                    onClick={this.isPlanLite() ? '' : this.handleSetLinkStatus.bind(
                      this, ID, rowData.is_prevented)}
                    className="pdav3_table_actions"><i
                className="fa fa-chain-broken fa-lg"></i>
                            </span>
              <span title="Delete link"
                    onClick={this.isPlanLite()
                      ? ''
                      : this.handleDeletePrivateLink.bind(this, cellData)}
                    className="pdav3_table_actions">
                              <i className="fa fa-remove fa-lg"/>
                        </span>
            </div>
          );
        }),
      ],
    };
    const wp_table = isItProtected
      ? <WPReTable list={data} config={configs}/>
      : null;
    const table = (
      <div>
        <div className='pda-toolbar'>
          {this.renderTableToolbar()}
        </div>
        <hr className={isItProtected ? '' : 'hidden'}/>
        {wp_table}
      </div>
    );
    const tableData = (
      loadingData ? UI_Utils.renderLoadingData() : table
    );
    return tableData;

  }

  renderAffiliateProgram () {
    return <AffiliateProgram/>;
  }

  renderFormTab () {
    return this.state.loadingData ? UI_Utils.renderLoadingData() :
      <PupForm type={this.state.type} postId={this.state.currentPostId}
               handleChangeTab={this.handleChangeTab}/>;
  }

  renderTabPrivateLinkUser (FormComponent) {
    const {currentPostId} = this.state;
    if (FormComponent) {
      const pdaFunc = {
        inform: this.inform,
        confirm: this.confirm,
        handleChangeTab: this.handleChangeTab,
      };
      return <FormComponent
        postId={currentPostId}
        pdaFunc={pdaFunc}/>;
    } else {
      return <PrivateLinkUserForm
        postId={currentPostId}
        handleChangeTab={this.handleChangeTab}/>;
    }

  }

  renderIpBlock (FormComponent) {
    const {currentPostId} = this.state;
    if (FormComponent) {
      const pdaFunc = {
        inform: this.inform,
      };
      return (
        // do something useful with the store, like passing it to a child
        // component where it can be used in lifecycle methods
        <FormComponent postId={currentPostId} pdaFunc={pdaFunc}/>
      );
    } else {
      return (
        // do something useful with the store, like passing it to a child
        // component where it can be used in lifecycle methods
        <IpBlockForm postId={currentPostId}/>
      );
    }
  }

  renderRef (RefComp) {
    const {currentPostId} = this.state;
    const pdaFunc = {
      inform: this.inform,
    };

    return (
      <RefComp postId={currentPostId} pdaFunc={pdaFunc}/>
    );
  }

  inform (message, isError) {
    if (isError) {
      toastr.error(message);
    } else {
      toastr.success(message);
    }
  }

  confirm (message, opts) {
    toastr.confirm(message, opts);
  }

  renderUserAccess (ARForm, MemFormComp) {
    const {currentPostId} = this.state;
    const {RolesAccess, plan, addUserRoles, membersSelect} = this.props;
    const pdaFunc = {
      inform: this.inform,
    };
    if (ARForm) {
      return this.state.loadingData ? UI_Utils.renderLoadingData() : <ARForm
        postId={currentPostId}
        handleChangeTab={this.handleChangeTab}
        rolesAccess={RolesAccess}
        plan={plan}
        addUserRoles={addUserRoles}
        membersSelect={membersSelect}
        pdaFunc={pdaFunc}
        MemForm={MemFormComp}
      />;
    } else {
      return this.state.loadingData ? UI_Utils.renderLoadingData() :
        <UserAccessForm
          postId={currentPostId}
          handleChangeTab={this.handleChangeTab}
          addUserRoles={addUserRoles}
          MemForm={MemFormComp}
        />;
    }
  }

  renderTableToolbar () {
    const { post, isItProtected, notLoadingUserRoleData, notLoadingMembershipData, isEncrypted, isProcessing } = this.state;
    const { RolesAccess, fileStatus, fileS3Status, membersSelect } = this.props;
    if (typeof (fileStatus.role_setting) !== 'undefined' &&
      fileStatus.role_setting !== null) {
      var roles_access = '';
      switch (fileStatus.role_setting.file_access_permission) {
        case 'admin_users':
          roles_access = 'Admin users';
          break;
        case 'author':
          roles_access = 'The file\'s author';
          break;
        case 'logged_users':
          roles_access = 'Logged-in users';
          break;
        case 'blank':
          roles_access = 'No user roles';
          break;
        case 'anyone':
          roles_access = 'Anyone';
          break;
        case 'custom_roles':
          roles_access = fileStatus.role_setting.whitelist_roles;
          break;
        default:
          roles_access = 'No user roles';
          break;
      }
    }


    let access_roles = '';
    let labelUserFAP = false;
    if (typeof (RolesAccess.userRolesAccess) != 'undefined') {
      switch (RolesAccess.userRolesAccess.type) {
        case 'admin-user':
          access_roles = 'Admin users';
          break;
        case 'author':
          access_roles = 'The file\'s author';
          break;
        case 'memberships':
          access_roles = pda_gold_v3_data.pda_membership_integration_activated ==
          -1 ? 'Custom memberships' : roles_access;
          break;
        case 'logger-in-user':
          access_roles = 'Logged-in users';
          break;
        case 'blank':
          access_roles = 'No user roles';
          break;
        case 'anyone':
          access_roles = 'Anyone';
          break;
        case 'custom-roles':
          access_roles = RolesAccess.userRolesAccess.roles.replace(/;/g, ' - ');
          break;
        case 'default':
          access_roles = roles_access;
          break;
        default:
          access_roles = roles_access;
          break;
      }
      if (typeof (RolesAccess.userRolesAccess.user_access) != 'undefined') {
        switch (RolesAccess.userRolesAccess.user_access.type.value) {
          case 'default':
            labelUserFAP = 'Default users';
            break;
          case 'no-users':
            labelUserFAP = 'No users';
            break;
          case 'custom-users':
            labelUserFAP = 'Custom users';
            break;
          default:
            access_roles = 'Default setting';
            break;
        }
      }
    }

    const s3Btn = post.s3_link
      ? (<input type="submit" className="button btn action pda-button"
                value={BUTTON_LABELS.UN_SYNC_TO_S3}
                onClick={this.unSyncFile}/>)
      : (<input type="submit" className="button btn action pda-button"
                value={BUTTON_LABELS.SYNC_TO_S3}
                onClick={this.syncFileToS3}/>);

    const isS3Activated = pda_gold_v3_data.pda_s3_activated;

    const privateLinksBtn = (
      <span>
                <input disabled={this.wpData.isLicenseExpired || this.isPlanLite()}
                       type="submit" className="button btn action pda-button"
                       value={__('Auto-generate new link')}
                       onClick={this.handleAddNewPrivateLink}/>
                <input disabled={this.wpData.isLicenseExpired} type="submit"
                       className="button btn action pda-button"
                       value={__('Customize new link')}
                       onClick={this.changeToCustomForm}/>
            </span>
    );

    const protectBtnLabel = isItProtected ?
      <button className="button btn action unprotect-btn pda-button"
              onClick={this.handleUnProtectThisFile}>{__('Unprotect this file')}
      </button> :
      <button type="submit" className="button btn action protect-btn pda-button"
              onClick={this.handleProtectThisFile}>{__('Protect this file')}
      </button>;

    const unprotect = (
      <span className="protection-status pda-unprotected">
				<i className="fa fa-times-circle" aria-hidden="true"></i> unprotected
			</span>
    );

    const protect = (
      <span className="protection-status">
				<i className="fa fa-check-circle" aria-hidden="true"></i> protected
			</span>
    );

    const statusFile = isItProtected ? protect : unprotect;

    const encryptionBtn = isEncrypted ? (
      <button className="button btn action encryption-btn pda-button"
              onClick={this.handleDecryptionFile}>{isProcessing ? __('Decrypting this file') : __('Decrypt this file')}
      </button> 
    ) : (
      <button className="button btn action encryption-btn pda-button"
              onClick={this.handleEncryptionFile}>{isProcessing ? __('Encrypting this file') : __('Encrypt this file')}
      </button> 
    );

    const encryptionStatus = isEncrypted ? (
      <span>
        <span data-tip data-for="pda-enc-status" className="encryption-status">
          <i className="fa fa-lock" aria-hidden="true"></i> encrypted
        </span>
        <ReactTooltip id='pda-enc-status' delayHide={1000} effect='solid' className="pda-enc-tooltip">
        This file <a target="_blank" rel="noopener" href="https://preventdirectaccess.com/docs/encrypt-wordpress-media-files/">is encrypted</a> to prevent unauthorized downloads from viewing
        </ReactTooltip>
      </span>
    ) : null;

    const title = __('This file is accessible to ') + access_roles +
      __('. Click to edit.');

    const loadingText = __('Loading...');
    let accessText = 'No user roles';
    if (!this.isPlanLite()) {
      accessText = notLoadingUserRoleData ? access_roles : loadingText;
    } else {
      accessText = access_roles ? access_roles : 'The file\'s author';
    }
    const access = isItProtected ? (
      <span title={title} onClick={this.changeToFileAccessPermission}
            className="access_permision protection-status">
				<i className="fa fa-user-circle-o"
           aria-hidden="true"></i> {accessText}
			</span>) : '';

    const membershipSelected = (membersSelect.noMember ||
      membersSelect.members[0] === 'memberships-default')
      ? ' Default memberships'
      : membersSelect.members[0] === 'no-memberships'
        ? ' No memberships'
        : ' Custom memberships';

    const titleMemberships = __('This file is accessible to ') +
      membershipSelected + __('. Click to edit.');
    const membershipAccess = isItProtected ? (
      <span title={titleMemberships} onClick={this.changeToFileAccessPermission}
            className="access_permision protection-status">
				<i className="fa fa-user-circle-o"
           aria-hidden="true"></i> {notLoadingMembershipData
        ? membershipSelected
        : loadingText}
			</span>) : '';

    const showMembershipAccessRoles = (pda_gold_v3_data.pda_membership_integration_activated !=
      -1 || post.is_file_deleted) ? '' : membershipAccess;

    const showAccessRoles = post.is_file_deleted ? '' : access;

    const s3_link = post.s3_link ? (fileS3Status.status ? (
      <span className="protection-status offloaded-to-s3"><i
        className="fa fa-check-circle"
        aria-hidden="true"></i> offloaded to S3</span>) : (
      <span className="protection-status synced-to-s3"><i
        className="fa fa-check-circle"
        aria-hidden="true"></i> synced to S3</span>)) : ('');

    const linkFile = (<span>{__('You\'re protecting ')}
      <a className="pda-orginal-link" target="_blank"
         href={post.edit_url}>{this.parseHtmlEnteties(post.title)}
			</a> file.
		</span>);

    const userAccessTitle = __('This file is accessible to ') + labelUserFAP +
      __('. Click to edit.');

    const isShowStatusUsers = isItProtected && labelUserFAP &&
      typeof (ip_block_server_data) !== 'undefined' &&
      ip_block_server_data.ip_block_activated == -1;
    const userAccess = isShowStatusUsers ? (
      <span title={userAccessTitle} onClick={this.changeToFileAccessPermission}
            className="access_permision protection-status">
				<i className="fa fa-user-circle-o"
           aria-hidden="true"></i> {notLoadingUserRoleData
        ? labelUserFAP
        : loadingText}
			</span>) : '';

    const protectedLink = isItProtected ? (
      <p className='wrap_protected_link'>
        <b>{__('Protected Link')}</b>
        <input readOnly type="text" value={post.edit_url}/>
		{!this.isPlanLite() && <button className="button btn action"
									   onClick={this.handleCopyProtectedLink.bind(this,
										 post.edit_url)}>{__('Copy link')}
		</button>
		}
      </p>
    ) : '';

    return (
      <div>
        <p>
          {linkFile}
          {statusFile}
          {encryptionStatus}
          {showAccessRoles}
          {userAccess}
          {showMembershipAccessRoles}
          {s3_link}
        </p>
        {protectedLink}
        <div className="pup-form actions">
          <div>
            {protectBtnLabel}
            {isItProtected ? encryptionBtn : null}
            {isItProtected ? privateLinksBtn : null}
            {isS3Activated === '1' && s3Btn}
            <span onClick={this.refreshData}
                  className={isItProtected ? '' : 'hidden'}>
					<i title="Refresh Data"
             className="fa fa-refresh fa-lg pup-reload "/>
			</span>
            {this.renderTableSummary()}
          </div>
        </div>
      </div>
    );
  }

  parseHtmlEnteties (str) {
    return str.replace(/&#([0-9]{1,4});/gi, function (match, numStr) {
      var num = parseInt(numStr, 10); // read num as normal number
      return String.fromCharCode(num);
    });
  }

  renderTableSummary () {
    const {total} = this.props;
    if (pda_gold_v3_data.stats_activated == -1) {
      const { isItProtected } = this.state;
      return (
        <div
          className={isItProtected ? 'pda-tbl-summary' : 'hidden'}>
          <h4 className="pda-sum">Total Private Download
            Links: {total.total_private_link} </h4>
          <h4 className="pda-sum">Total Clicks: {total.total_click} </h4>
        </div>
      );
    }
  }

  renderCloseBtn () {
    return (<span title="Close"
                  className="close_btn"
                  onClick={this.handleClosePopup}><i
      className="fa fa-times fa-lg"/></span>);
  }

  handleShowPopup () {
    this.child.handleOpenPopup();
  }

  renderFileStatus (isProtected) {
    if (isProtected) {
      jQuery(`#pda-v3-text_${this.state.currentPostId}`).
        html('<i class="fa fa-check-circle" aria-hidden="true"></i> protected');
      jQuery(`#pda-v3-text_${this.state.currentPostId}`).
        removeClass('pda-unprotected');
      jQuery(`#pda-v3-text_${this.state.currentPostId}`).
        prop('title', 'This file is protected');
      this.setState({
        isItProtected: false,
      });
    } else {
      jQuery(`#pda-v3-text_${this.state.currentPostId}`).html(
        '<i class="fa fa-times-circle" aria-hidden="true"></i> unprotected');
      jQuery(`#pda-v3-text_${this.state.currentPostId}`).
        addClass('pda-unprotected');
      jQuery(`#pda-v3-text_${this.state.currentPostId}`).
        prop('title', 'This file is unprotected');
    }
  }

  renderEncryptionStatus (currentPostId, isEncrypted) {
    if (isEncrypted) {
      jQuery(`#pda-v3-encryption_${currentPostId}`).show();

      this.setState({
        isEncrypted: false,
      });
    } else {
      jQuery(`#pda-v3-encryption_${currentPostId}`).hide();
    }
  }

  handleClosePopup () {
    const {changeTab} = this.props;
    const {isItProtected, isEncrypted, currentPostId} = this.state;
    changeTab(TABS.TABLE);
    this.child.handleClosePopup();
    this.renderFileStatus(isItProtected);
    this.renderEncryptionStatus(currentPostId, isEncrypted);
  }

  handleProtectFileEvent () {
    const self = this;
    jQuery('.pda_gold_btn').on('click', function (evt) {
      self.handleShowPopup();
      const currentPostId = jQuery(this).attr('id').split('-')[1];
      // const newState = { ...self.state, currentPostId, loadingData: true };
      self.setState(prevState => ({
        ...prevState,
        currentPostId,
        loadingData: true,
      }));
      self.checkIsProtectedFile(currentPostId);
      self.checkIsMembershipRole(currentPostId);
    });
  }

  handleAddNewPrivateLink (evt) {
    evt.preventDefault();
    const {newUrl} = this.props;
    const {currentPostId} = this.state;
    this.showLoading();
    if (currentPostId) {
      newUrl(currentPostId).then(() => {
        this.hideLoading();
        const {createdUrl, fetchUrls} = this.props;
        if (createdUrl.isError) {
          toastr.error(MESSAGES.ERR_CREATE_NEW_PRIVATE_LINK);
        } else {
          toastr.success(MESSAGES.CREATE_NEW_PRIVATE_LINK);
          fetchUrls(currentPostId);
        }
      });
    }
  }

  handleProtectThisFile (evt) {
    evt.preventDefault();
    const { protectThisFile, registerTab, tabs } = this.props;
    registerTab({
      'name': 'pda/table',
      'description': 'Prevent Direct Access',
      priority: 0,
    });

    const {currentPostId} = this.state;
    this.showLoading();
    protectThisFile(currentPostId).then(() => {
      this.hideLoading();
      const {protectFile} = this.props;
      if (protectFile.error) {
        toastr.error(protectFile.response);
      } else {
        if (this.isPlanLite() && protectFile.response.error) {
          toastr.error(protectFile.response.error);
        } else {
          toastr.success(MESSAGES.PROTECT_FILE);
          jQuery(`#pda-protect-file_${currentPostId}`).text('Unprotect');
          this.reload();
        }
      }
    })
    .catch(error => {
      if (error.response.status === 400) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
      }

      this.reload();
    });
  }

  handleEditPrivateUrl (editingId) {
    this.setState(prevState => ({
      ...prevState,
      editingId,
    }));
  }

  handleSetLinkStatus (id, is_prevented) {
    const {updateUrlStatus} = this.props;
    is_prevented = is_prevented === '1' ? true : false;
    this.showLoading();
    updateUrlStatus(id, is_prevented).then(() => {
      const {updateUrlResponse, fetchUrls} = this.props;
      if (updateUrlResponse.result.isError) {
        toastr.error(MESSAGES.ERR_UPDATE_PRIVATE_LINK);
      } else {
        const {currentPostId, type} = this.state;
        toastr.success(MESSAGES.UPDATE_LINK_DATA);
        fetchUrls(currentPostId, type);
      }
      this.hideLoading();
    });
  }

  handleCopyPrivateLink (ID) {
    const {privateUrls} = this.props;
    const link = privateUrls.all.find(f => f.ID == ID);
    UI_Utils.handleCopyBtn(link.full_url);
  }

  handleCopyProtectedLink (url) {
    UI_Utils.handleCopyBtn(url, MESSAGES.COPY_PROTECTED_LINK_TO_CLIPBOARD);
  }

  checkIsProtectedFile (currentPostId) {
    const {isItProtectedFile, fetchUrls, checkStatusFile} = this.props;
    const isS3Activated = pda_gold_v3_data.pda_s3_activated;
    if (isS3Activated) {
      checkStatusFile(currentPostId);
    }
    isItProtectedFile(currentPostId).then(() => {
      const {fileStatus, getTotalPrivateLinks, getUserRolesIpBlock} = this.props;
      if (fileStatus.error) {
        toastr.error(MESSAGES.ERR_CALL_DATA);
        this.hideLoading();
      } else {
        this.setState(prevState => (
          {
            ...prevState,
            isItProtected: fileStatus.is_protected,
            post: fileStatus.post,
            isEncrypted: fileStatus.is_encrypted ? true : false,
          }
        ));
        if (fileStatus.is_protected) {
          fetchUrls(currentPostId).then(() => {
            this.hideLoading();
          });
          if (pda_gold_v3_data.stats_activated == -1) {
            getTotalPrivateLinks(currentPostId);
          }

          if (this.isPlanLite()) {
            return;
          }
          getUserRolesIpBlock(currentPostId).catch(error => {
            console.log('Error happened due to:', error);
            toastr.error(error.message);
          }).finally(() => {
            this.setState({
              notLoadingUserRoleData: true,
            });
          });
        } else {
          this.hideLoading();
        }
      }
    });
  }

  reload () {
    const { currentPostId } = this.state;
    this.setState({
      notLoadingUserRoleData: false,
      notLoadingMembershipData: false,
    });
    this.showLoading();
    this.checkIsProtectedFile(currentPostId);
    this.checkIsMembershipRole(currentPostId);
  }

  refreshData (evt) {
    evt.preventDefault();
    this.reload();
  }

  handleDeletePrivateLink (id) {
    const toastrConfirmOptions = {
      onOk: () => {
        const {deleteUrl} = this.props;
        deleteUrl(id).then(() => {
          const {deleteUrlResponse, fetchUrls} = this.props;
          if (deleteUrlResponse.result.isError) {
            toastr.error(MESSAGES.ERR_DELETE_PRIVATE_LINK);
          } else {
            toastr.success(MESSAGES.DELETE_PRIVATE_LINK);
            fetchUrls(this.state.currentPostId);
          }
        });
      },
      okText: 'Yes',
      cancelText: 'No',
    };
    toastr.confirm(MESSAGES.CONFIRM_DELETE_LINK, toastrConfirmOptions);
  }

  changeToCustomForm (evt) {
    evt.preventDefault();
    const {changeTab} = this.props;
    changeTab(TABS.FORM);
    this.childTab && this.childTab.handleSelect(TABS.FORM);
  }

  changeToFileAccessPermission (evt) {
    evt.preventDefault();
    const {changeTab} = this.props;
    let tabFileAccessPermission = TABS.FILE_ACCESS_PERMISSION;
    if (ip_block_server_data.pda_magic_link_activated == -1) {
      tabFileAccessPermission += 1;
    }
    changeTab(tabFileAccessPermission);
    this.childTab && this.childTab.handleSelect(tabFileAccessPermission);
  }

  handleUnProtectThisFile (evt) {
    evt.preventDefault();
    const {unProtectThisFile} = this.props;
    const {currentPostId} = this.state;
    this.showLoading();
    unProtectThisFile(currentPostId).then(() => {
      this.hideLoading();
      const {protectFile} = this.props;
      if (protectFile.error) {
        toastr.error(protectFile.response);
      } else {
        toastr.success(MESSAGES.UN_PROTECT_FILE);
        jQuery(`#pda-protect-file_${currentPostId}`).text('Protect');
        this.reload();
      }
    })
    .catch(error => {
      if (error.response.status === 400) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
      }

      this.reload();
    });
  }

  handleEncryptionFile (evt) {
    evt.preventDefault();
    const { currentPostId } = this.state;

    this.setState({ isProcessing: true });
    encryptFile(currentPostId).then(() => {
      this.setState({isEncrypted: true});
      toastr.success(MESSAGES.ENCRYPT_FILE);
    }).finally(() => {
      this.setState({ isProcessing: false });
    });
  }

  handleDecryptionFile (evt) {
    evt.preventDefault();
    const { currentPostId } = this.state;
    
    this.setState({ isProcessing: true });
    decryptFile(currentPostId).then(() => {
      this.setState({isEncrypted: false});
      toastr.success(MESSAGES.DECRYPT_FILE);
    }).finally(() => {
      this.setState({ isProcessing: false });
    });
  }

  setDefaultPrivateLink (id) {
    const {setDefault} = this.props;
    this.showLoading();
    setDefault(id, this.state.currentPostId).then(() => {
      this.reload();
      this.hideLoading();
    });
  }

  syncFileToS3 () {
    const {currentPostId} = this.state;
    const {syncFileToS3} = this.props;
    this.showLoading();
    syncFileToS3(currentPostId).then(() => {
      this.hideLoading();
      const {s3Response} = this.props;
      if (s3Response.isError) {
        toastr.error(s3Response.message);
      } else {
        this.reload();
        jQuery(`#pda-s3-sync-file_${currentPostId}`).text('Unsync');
        const {checkStatusFile} = this.props;
        checkStatusFile(currentPostId).then(() => {
          const {fileS3Status} = this.props;
          if (fileS3Status.status) {
            jQuery(`#pda-v3-wrap-status_${currentPostId}`).append(
              `<span id="pda-s3-sync-file-status_${currentPostId}" title="This file is offloaded to Amazon S3" class="protection-status offloaded-to-s3"><i class="fa fa-check-circle" aria-hidden="true"></i> offloaded</span>`,
            );
          } else {
            jQuery(`#pda-v3-wrap-status_${currentPostId}`).append(
              `<span id="pda-s3-sync-file-status_${currentPostId}" title="This file is synced to Amazon S3" class="protection-status synced-to-s3"><i class="fa fa-check-circle" aria-hidden="true"></i> synced</span>`,
            );
          }
        });
      }
    });

  }

  unSyncFile () {
    const {currentPostId} = this.state;
    const {unSyncFileFromS3} = this.props;
    this.showLoading();
    unSyncFileFromS3(currentPostId).then(() => {
      this.hideLoading();
      const {s3Response} = this.props;
      if (s3Response.isError) {
        return toastr.error(s3Response.message);
      } else {
        this.reload();
      }
      jQuery(`#pda-s3-sync-file_${currentPostId}`).text('Sync');
      jQuery(`#pda-s3-sync-file-status_${currentPostId}`).remove();
    });
  }

  checkIsMembershipRole (currentPostId) {
    const { getMembersSelect } = this.props;
    if (this.isPlanLite()) {
      return;
    }
    getMembersSelect(currentPostId).catch(error => {
      console.log('Error happened due to:', error);
      toastr.error(error.message);
    }).finally(() => {
      this.setState({
        notLoadingMembershipData: true,
      });
    });
  }

  showLoading () {
    this.setState(prevState => ({
      ...prevState,
      loadingData: true,
    }));
  }

  hideLoading () {
    this.setState(prevState => ({
      ...prevState,
      loadingData: false,
    }));
  }
}

const mapStateToProps = state => {
  return {
    privateUrls: state.privateUrls,
    createdUrl: state.createUrls,
    deleteUrlResponse: state.deleteUrl,
    updateUrlResponse: state.updateUrl,
    currentTab: state.tab,
    protectFile: state.protectFile,
    fileStatus: state.isProtectedFile,
    total: state.total,
    RolesAccess: state.userRolesAccess,
    fileS3Status: state.fileS3Status,
    s3Response: state.s3Link,
    plan: state.getPlan,
    membersSelect: state.membersSelect,
    formTabs: state.tabs,
    initData: state.initData,
    // allRolesSetting: state.allRolesSetting
  };
};

store.dispatch(getPlan());

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    fetchUrls,
    newUrl,
    deleteUrl,
    updateUrlStatus,
    changeTab,
    updateDataUrl,
    protectThisFile,
    unProtectThisFile,
    isItProtectedFile,
    setDefault,
    getTotalPrivateLinks,
    syncFileToS3,
    getPlan,
    unSyncFileFromS3,
    getUserRolesIpBlock,
    checkStatusFile,
    getMembersSelect,
    registerTab,
    fetchInitData,
    addUserRoles,
  }, dispatch);
};

const PPPApp = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
)(App);

document.addEventListener('DOMContentLoaded', function () {
  var divElement = document.createElement('div');
  divElement.setAttribute('class', 'pda_v3_react_root');
  document.body.appendChild(divElement);
  ReactDOM.render(
    <Provider store={store}>
      <PPPApp/>
    </Provider>,
    divElement);
});

export default {
  service: PDAService,
};
